import React from 'react';

const getShippingLineLinkUrl = (supplierName, booking_number) => {
	let linkUrl = '';
	if (supplierName === 'MAERSK') {
		linkUrl = 'https://www.maersk.com/shipmentbinder/t/' + booking_number + '/show';
	} else if (supplierName === 'CMA') {
		linkUrl = 'https://www.cma-cgm.com/ebusiness/shipment/detail/' + booking_number;
	} else if (supplierName === 'EVERGREEN') {
		linkUrl = 'https://ct.shipmentlink.com/servlet/TDB1_CargoTracking.do';
	} else if (supplierName === 'HMM') {
		linkUrl = 'https://www.hmm21.com/e-service/export/myExport/myExportOverview.do?bkgNo=' + booking_number;
	} else if (supplierName === 'HAPAG') {
		linkUrl = 'https://www.hapag-lloyd.com/solutions/booking/#/list/booking-details?booking=' + booking_number;
	} else if (supplierName === 'ONE LINE') {
		linkUrl =
			'https://ecomm.one-line.com/one-ecom/manage-shipment/cargo-tracking?trakNoParam=' +
			booking_number +
			'&trakNoTpCdParam=B';
	}
	return (
		<a rel="noreferrer" href={linkUrl} target="_blank">
			{supplierName}
		</a>
	);
};

export default getShippingLineLinkUrl;
